export * as Api from './api';
export * as Schema from './schema';
export var InvestorType;
(function (InvestorType) {
    InvestorType["EverydayInvestor"] = "EVERYDAY_INVESTOR";
    InvestorType["SophisticatedInvestor"] = "SOPHISTICATED_INVESTOR";
    InvestorType["HighNetWorthInvestor"] = "HIGH_NET_WORTH_INVESTOR";
    InvestorType["ProfessionalClient"] = "PROFESSIONAL_CLIENT";
    InvestorType["Advised"] = "ADVISED";
    InvestorType["ClassificationSkipped"] = "CLASSIFICATION_SKIPPED";
})(InvestorType || (InvestorType = {}));
export var AccountType;
(function (AccountType) {
    AccountType["Individual"] = "INDIVIDUAL";
    AccountType["LegalEntity"] = "LEGAL_ENTITY";
})(AccountType || (AccountType = {}));
export var IncomeSource;
(function (IncomeSource) {
    IncomeSource["EmploymentIncome"] = "EMPLOYMENT_INCOME";
    IncomeSource["PensionsAndRetirementFunds"] = "PENSIONS_AND_RETIREMENT_FUNDS";
    IncomeSource["LegalSettlements"] = "LEGAL_SETTLEMENTS";
    IncomeSource["BusinessProfits"] = "BUSINESS_PROFITS";
    IncomeSource["InvestmentsAndSavings"] = "INVESTMENTS_AND_SAVINGS";
    IncomeSource["Inheritance"] = "INHERITANCE";
    IncomeSource["SaleOfAssets"] = "SALE_OF_ASSETS";
    IncomeSource["Gifts"] = "GIFTS";
})(IncomeSource || (IncomeSource = {}));
export var InvestorCustomTagCategory;
(function (InvestorCustomTagCategory) {
    InvestorCustomTagCategory["InvestorGroup"] = "investor_group";
    InvestorCustomTagCategory["Source"] = "source";
    InvestorCustomTagCategory["InternalContact"] = "internal_contact";
    InvestorCustomTagCategory["Other"] = "other";
})(InvestorCustomTagCategory || (InvestorCustomTagCategory = {}));
export var InvestorRealm;
(function (InvestorRealm) {
    InvestorRealm["Eis"] = "eisInvestor";
    InvestorRealm["Lp"] = "lpInvestor";
})(InvestorRealm || (InvestorRealm = {}));
//# sourceMappingURL=index.js.map